import {DropdownMenuCheckboxItem} from '@/base/ui/dropdownMenu'

export interface IWuMenuCheckboxItemProps {
  checked: boolean
  onSelect: (value: boolean) => void
  disabled?: boolean
  children?: React.ReactNode
  preventCloseOnSelect?: boolean
}
export const WuMenuCheckboxItem: React.FC<IWuMenuCheckboxItemProps> = props => {
  const {checked, onSelect, children, disabled, preventCloseOnSelect} = props

  return (
    <DropdownMenuCheckboxItem
      disabled={disabled}
      checked={checked}
      onCheckedChange={onSelect}
      onSelect={e => preventCloseOnSelect && e.preventDefault()}
    >
      {children}
    </DropdownMenuCheckboxItem>
  )
}
